import routes from './waitingList.routes';

export const waitingListModule = {
    routes
};